import styles from './MobileCommunity.module.scss';
import { useFm } from '@web3/base-hooks';
import { appPath } from '@web3/base-utils';

export const MobileCommunity = () => {
  const fm = useFm();

  return (
    <div className={styles.community}>
      <div className={styles.community__title}> Join Bybit WEB3 bbSol</div>

      <div className={styles.community__content}>
        <div className={styles.community__content__about}>
          {fm('join_community')}
        </div>
        <div className={styles.community__content__socials}>
          {SOCIAL_BUTTONS.map((button) => (
            <a
              key={button.key}
              className={styles.social}
              target="_blank"
              href={button.url}
            >
              <img src={button.icon} width={16} height={16} alt={button.name} />
              <p>{button.name}</p>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

interface SocialButton {
  key: string;
  name: string;
  icon: string;
  url: string;
}

const SOCIAL_BUTTONS: SocialButton[] = [
  {
    key: 'telegram',
    name: 'Telegram',
    icon: `${appPath}/svg/home/telegram.svg`,
    url: 'https://t.me/BybitEnglish',
  },
  {
    key: 'twitter',
    name: 'Twitter',
    icon: `${appPath}/png/bybitsol/twitter.png`,
    url: 'https://twitter.com/Bybit_Web3',
  },
];
